import {activeExperiments} from '~/activeExperiments'
import {type ActiveExperiment} from './types'

export function getActiveExperiment(pathname: string): ActiveExperiment | undefined {
  return activeExperiments.find(experiment => experiment.route === pathname)
}
